import __range__ from './range'

// Scene 全体を管理する model クラス
// ドラッグの結果の移動距離やダブルクリックの結果の倍率などを管理している
// magnify: 拡大
// minify: 縮小
// justify: 全体を表示
// move: ドラッグによる移動
class Scene {
  static initClass() {
    this.prototype.magnificationRatios = [1.0, 2.0, 4.0, 8.0]

    this.prototype.smoothDelta = 0.05
  }
  constructor(view) {
    this.view = view
    this.magnificationRatioIndex = 0
    this.dx = 0
    this.dy = 0
  }

  startMove(x, y) {
    this.initialDx = this.dx
    this.initialDy = this.dy
    this.initialX = x
    return (this.initialY = y)
  }

  move(x, y) {
    this.dx = this.initialDx + (this.initialX - x)
    this.dy = this.initialDy + (this.initialY - y)

    const leafletSize = this.view.leafletView.leaflet.size()
    const maxDx = leafletSize.width / 2
    const maxDy = leafletSize.height / 2

    if (this.dx > maxDx) {
      this.dx = maxDx
    } else if (this.dx < -maxDx) {
      this.dx = -maxDx
    }

    if (this.dy > maxDy) {
      this.dy = maxDy
    } else if (this.dy < -maxDy) {
      this.dy = -maxDy
    }

    return this.view.render()
  }

  magnificationRatio() {
    if (this.smoothMagnificationRatio) {
      return this.smoothMagnificationRatio
    } else {
      return this.magnificationRatios[this.magnificationRatioIndex]
    }
  }

  headerHeight() {
    // 76 is the default height of header. set here for initial run fail safe.
    return this.calcHeaderHeight()
  }

  calcHeaderHeight() {
    const baseHeaderHeight = this.view.headerElement.outerHeight() || 76
    if (this.view.importantNoticeElement.is(':visible')) {
      return baseHeaderHeight + this.view.importantNoticeElement.outerHeight()
    }
    return baseHeaderHeight
  }

  setSize() {
    this.width = $(window).width()
    this.height = $(window).height() - this.headerHeight()
    return this.view.setSize()
  }

  center() {
    return {
      x: this.width / 2,
      y: this.height / 2 + this.headerHeight(),
    }
  }
  maxMagnificationRatio() {
    return Math.max(...Array.from(this.magnificationRatios || []))
  }

  minMagnificationRatio() {
    return Math.min(...Array.from(this.magnificationRatios || []))
  }

  smoothMagnify(x, y) {
    const before = this.magnificationRatio()
    if (this.smoothMagnificationRatio) {
      this.smoothMagnificationRatio += this.smoothDelta
    } else {
      this.smoothMagnificationRatio = this.magnificationRatio() + this.smoothDelta
    }
    if (this.smoothMagnificationRatio > this.maxMagnificationRatio()) {
      this.smoothMagnificationRatio = this.maxMagnificationRatio()
    }
    const after = this.magnificationRatio()
    this.convertLocationWithMaginify(before, after, x, y)
    return this.view.render()
  }

  smoothMinify(x, y) {
    const before = this.magnificationRatio()
    if (this.smoothMagnificationRatio) {
      this.smoothMagnificationRatio -= this.smoothDelta
    } else {
      this.smoothMagnificationRatio = this.magnificationRatio() - this.smoothDelta
    }

    if (this.smoothMagnificationRatio < this.minMagnificationRatio()) {
      this.smoothMagnificationRatio = this.minMagnificationRatio()
    }
    const after = this.magnificationRatio()
    this.convertLocationWithMaginify(before, after, x, y)
    return this.view.render()
  }

  magnifiable() {
    return this.magnificationRatio() < this.maxMagnificationRatio()
  }

  minifiable() {
    return this.magnificationRatio() > this.minMagnificationRatio()
  }

  justifiable() {
    return this.minifiable() || Math.abs(this.dx - 0.0) > 0.01 || Math.abs(this.dy - 0.0) > 0.01
  }

  justify() {
    this.smoothMagnificationRatio = null
    this.magnificationRatioIndex = 0
    this.dx = this.dy = 0
    return this.view.render(true)
  }

  magnify(x = null, y = null) {
    let newIndex
    const before = this.magnificationRatio()
    this.smoothMagnificationRatio = null

    for (let index = 0; index < this.magnificationRatios.length; index++) {
      var _ratio = this.magnificationRatios[index]
      if (_ratio > before) {
        newIndex = index
        break
      }
    }

    if (newIndex) {
      this.magnificationRatioIndex = newIndex
    } else {
      this.magnificationRatioIndex = 0
      this.dx = this.dy = 0
      x = y = null
    }

    const after = this.magnificationRatio()
    this.convertLocationWithMaginify(before, after, x, y)
    return this.view.render(true)
  }

  minify(x = null, y = null) {
    let newIndex
    const before = this.magnificationRatio()
    this.smoothMagnificationRatio = null

    const indexes = __range__(this.magnificationRatios.length - 1, 0, true)
    for (var index of indexes) {
      var _ratio = this.magnificationRatios[index]
      if (_ratio < before) {
        newIndex = index
        break
      }
    }

    if (newIndex === 0) {
      this.dx = this.dy = 0
      x = y = null
    }

    this.magnificationRatioIndex = newIndex

    const after = this.magnificationRatio()
    this.convertLocationWithMaginify(before, after, x, y)
    return this.view.render(true)
  }

  convertLocationWithMaginify(before, after, x = null, y = null) {
    const center = this.center()
    if (!x) {
      ;({ x } = center)
    }
    if (!y) {
      ;({ y } = center)
    }
    const centerdx = x - center.x
    const centerdy = y - center.y
    const ratio = after / before

    this.dx = this.dx * ratio + (ratio - 1.0) * centerdx
    return (this.dy = this.dy * ratio + (ratio - 1.0) * centerdy)
  }
}

export default Scene;
